<script>
  import { activeMediaOutlet } from '$lib/states/index.svelte';

  let { mediaOutlets = [] } = $props();

  const setActiveMediaOutlet = (mediaOutlet) => {
    activeMediaOutlet.value = mediaOutlet;
  };

  const onSelectMediaOutlet = (event) => {
    setActiveMediaOutlet(event.target.value);
  };
</script>

<div class="media-outlet-nav">
  <div class="row"></div>
  <div class="lead-in">Filter polls by major Israeli media outlets:</div>
  <div class="media-outlet-flex">
    <button
      class="media-outlet-button all"
      class:active={activeMediaOutlet.value === 'all'}
      onclick={() => setActiveMediaOutlet('all')}>All</button
    >
    <div class="spacer"></div>
    <select
      class="media-outlet-select"
      value={activeMediaOutlet.value === 'all' ? '' : activeMediaOutlet.value}
      onchange={onSelectMediaOutlet}
    >
      <option value="" disabled>Choose a media outlet…</option>
      {#each mediaOutlets as mediaOutlet}
        <option value={mediaOutlet.slug}>{mediaOutlet.name}</option>
      {/each}
    </select>
  </div>
</div>

<style lang="scss">
  @use 'reset';
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  div.spacer {
    display: inline-block;
    border-left: 1px solid var(--theme-colour-text-secondary);
    opacity: 0.4;
    margin: 0 10px;
    height: 18px;
    vertical-align: text-bottom;
  }
  button,
  select.media-outlet-select {
    @include mixins.font-note;
    @include mixins.text-sm;
    font-weight: 500;
    color: var(--theme-colour-text-secondary);
  }
  button,
  select.media-outlet-select {
    background: var(--theme-colour-background);
    border: 1px solid var(--theme-colour-text-secondary);
    border-radius: 4px;
    padding: 3px 8px;
    cursor: pointer;
  }
  button {
    border: 1px solid var(--theme-colour-text-secondary) !important;
    padding: 5px 10px !important;

    margin-right: 16px;
    text-align: center;
    opacity: 0.4;
    &.all {
      margin-right: 0;
    }
    &.active {
      opacity: 1;
      color: var(--theme-colour-text-primary);
      border-color: var(--theme-colour-accent);
    }
  }
  button:hover,
  select.media-outlet-select:hover {
    opacity: 1;
    color: var(--theme-colour-text-primary);
  }
  .lead-in {
    @include mixins.font-note;
    margin-top: 1.5rem;
    font-size: 0.85rem;
    font-style: italic;
    margin-bottom: 0.25rem;
    line-height: 1;
  }
</style>
